import {Component, Input} from '@angular/core';

@Component({
  selector: 'status-indicator',
  templateUrl: 'status-indicator.html',
  styleUrls: ['status-indicator.scss'],
})
export class StatusIndicator {

  @Input() public level: 'inactive' | 'low' | 'medium' | 'high';

  public get indicatorClass(): string {
    let className: string = 'indicator ';

    if (this.level && this.level !== 'inactive') {
      className = className + this.level;
    }

    return className;
  }

}
